import React, { useState, useEffect } from 'react';
import { RESOURCES } from '../content/common';
import PLAYER from '../playerData';
import { ASSETS } from '../assetManifest';

function HUD() {
  const [resources, setResources] = useState(PLAYER.resources);
  const [nextEnergyIn, setNextEnergyIn] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const timeSinceLastReplenish = now - PLAYER.lastEnergyReplenish;
      const timeUntilNext = Math.max(0, 10 - Math.floor(timeSinceLastReplenish / 1000));
      
      setNextEnergyIn(timeUntilNext);
      
      // Check if 10 seconds have passed since last replenish
      if (timeSinceLastReplenish >= 10000 && PLAYER.resources.energy < PLAYER.maxEnergy) {
        PLAYER.resources.energy = Math.min(PLAYER.maxEnergy, PLAYER.resources.energy + 1);
        PLAYER.lastEnergyReplenish = now;
      }
      
      setResources({...PLAYER.resources});
    }, 100);

    return () => clearInterval(interval);
  }, [resources]);

  // Render energy separately
  const renderEnergy = () => {
    return (
      <div className="EnergyIndicatorDetails w-[100px] h-[40px] relative">
        <img 
          src={ASSETS.ui.indicatorBackground.path} 
          alt="Indicator Background" 
          className="HudIndicatorBg w-[85px] h-8 absolute right-0 top-1/2 -translate-y-1/2"
        />
        <div className="w-12 h-4 text-center text-white text-xs font-extrabold font-['Asap'] capitalize leading-[16px] absolute right-[18px] top-1/2 -translate-y-1/2">
          {resources.energy}/{PLAYER.maxEnergy}
        </div>
        <img 
          src={RESOURCES.energy.icon} 
          alt="Energy" 
          className="w-[40px] h-[40px] absolute left-0 top-1/2 -translate-y-1/2"
        />
        <img 
          src={ASSETS.ui.plusButton.path} 
          alt="Plus" 
          className="w-[16px] h-[16px] absolute right-[3px] top-1/2 -translate-y-1/2 cursor-pointer"
        />
        {resources.energy < PLAYER.maxEnergy && (
          <span className="text-[9px] text-white opacity-75 absolute right-[18px] bottom-0">
            +1 in {nextEnergyIn}s
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="Hud w-full h-[75px] justify-center items-center inline-flex">
      <div className="HudDetails w-full h-[75px] relative">
        <div 
          className="HudBg w-full h-[75px]"
          style={{ 
            backgroundColor: "#302C53",
            boxShadow: "0px 8px 15px 2px rgba(0, 0, 0, 0.7), 0px 12px 20px 5px rgba(0, 0, 0, 0.4)"
          }}
        />
        
        <div className="flex justify-around items-center absolute inset-0 px-4">
          {renderEnergy()}
          
          {Object.entries(RESOURCES).filter(([key]) => key !== 'energy').map(([key, config], index) => (
            <div
              key={key}
              className={`${key === 'gold' ? 'CoinsIndicator w-[100px] h-9' : 'GemIndicator w-24 h-[40px]'} relative`}
            >
              <img 
                src={ASSETS.ui.indicatorBackground.path} 
                alt="Indicator Background" 
                className="HudIndicatorBg w-[85px] h-8 absolute right-0 top-1/2 -translate-y-1/2"
              />
              <img 
                src={config.icon} 
                alt={key}
                className={`${key === 'gold' ? 'w-[32px] h-[32px]' : 'w-[40px] h-[40px]'} absolute left-0 top-1/2 -translate-y-1/2`}
              />
              <img 
                src={ASSETS.ui.plusButton.path} 
                alt="Plus" 
                className="w-[16px] h-[16px] absolute right-[3px] top-1/2 -translate-y-1/2 cursor-pointer"
              />
              <div className="w-12 h-4 text-center text-white text-xs font-extrabold font-['Asap'] capitalize leading-[16px] absolute right-[18px] top-1/2 -translate-y-1/2">
                {resources[key].toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HUD;
